import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { FileUploadService } from '../file-upload.service';
import { FileUpload } from '../file-upload';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class FileUploadComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private fileUploadService: FileUploadService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.fileUpload = data.fileUpload,
			this.statuses = fileUploadService.statuses;
	}

	@Input() fileUpload: FileUpload;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	fileUploadId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'fileUploadId': [],
		'name': [
			{ type: 'required', message: 'Required' }],
		'description': [],
		'fileName': [],
		'taskId': [],
		'file': [],
		'contentType': ["PNG"]
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole fileUpload object
		if (this.fileUpload) {
			this.fileUploadId = this.fileUpload.fileUploadId;
			this.fixDates();
			this.form1.patchValue(this.fileUpload);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.fileUploadId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			console.log("this.form1.value : "+this.form1.value);
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.fileUploadService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.fileUpload = res.data.fileUpload;
						this.doAdd.emit(this.fileUpload);
					},
					(err: any) => {
						console.log('fileUpload-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('fileUpload: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.fileUploadService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.fileUpload = res.data.fileUpload;
						this.doUpdate.emit(this.fileUpload);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.fileUploadService.delete(this.fileUpload.fileUploadId)
				.subscribe(
					(res: any) => {
						console.log('fileUpload-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.fileUpload);
					},
					(err: any) => {
						console.log('fileUpload-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			fileUploadId: [this.fileUploadId],
			name: ['', Validators.required],
			description: [],
			fileName: [],
			taskId: [],
			file: [],
			contentType: ["PNG"]
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.fileUpload.fileUploadDate = moment(this.fileUpload.fileUploadDate).toDate();
	}
}
